import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import { FIB } from "../../../config/constants";
import otherQuestionUtils, { getTriggerAnswers } from "./_otherQuestionUtils";
import { passesIndicatorRule } from "../../../store/helpers/rules";
var QUESTION_TYPE = FIB.QUESTION_TYPE;
var type = QUESTION_TYPE.QUESTION_TYPE_OTHER;
export default {
  type: type,
  requiresTransaction: false,
  getTriggerAnswers: getTriggerAnswers,

  /**
   * Determines if a Other question should be added to the selection purely based on counts.
   */
  selectBasedOnCounts: function () {
    var _selectBasedOnCounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      var survey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              survey = context.survey;

              if (!(context.selection.countByType(type) >= survey.other.maximum)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              return _context.abrupt("return", true);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function selectBasedOnCounts(_x) {
      return _selectBasedOnCounts.apply(this, arguments);
    }

    return selectBasedOnCounts;
  }(),

  /**
   * Determines if an Other question should be added to the selection, ignoring counts.
   */
  select: function () {
    var _select = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      var survey;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              survey = context.survey; // Apply the indicator rule

              if (passesIndicatorRule(survey.other.indicatorRule)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", false);

            case 3:
              return _context2.abrupt("return", true);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function select(_x2) {
      return _select.apply(this, arguments);
    }

    return select;
  }(),

  /**
   * Renders a questions Screen
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return otherQuestionUtils.render(context);

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function render(_x3) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    return otherQuestionUtils.parseAnswer(context);
  }
};